import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Card,
  CardHeader,
  DropdownItem,
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
} from "reactstrap";
import RequestManager from "../../singletons/RequestManager";
import Switch from "react-switch";
import LoadingOverlay from "react-loading-overlay";
import InventoryPrice from "../../components/InventoryPrice/InventoryPriceNormal";
import "react-table/react-table.css";
import { now } from "core-js/fn/date";
import config from "../../config";
import { BrowserRouter, Route  } from 'react-router-dom';
import noticationlogo from "../../assets/img/brand/highlighted-logo.png";
import {generateEpochTimestamp, generateSignature} from "../../utils/helper";
import "./inventory.css"
//import {useParams} from 'react-router-dom'
import {
  TIME_INTERVAL_ORDER,
} from "../../config/Constants";
let player;
const filterData = (data = [], value) => {
  let filteredArr = data.filter((stock) => {
    // eslint-disable-next-line
    stock.node.sku.product.category.name + " - " + stock.node.referenceName;
    console.log(
      " stock.node.sku.product.category.name",
      stock.node.sku.product.category.name.toLowerCase()
    );
    return (
      !value ||
      stock.node.sku.product.category.name
        .toLowerCase()
        .includes(value.toLowerCase()) ||
      stock.node.referenceName.toLowerCase().includes(value.toLowerCase()) ||
      (stock.node.locallngName &&
        stock.node.locallngName.toLowerCase().includes(value.toLowerCase()))
    );
  });
  return filteredArr;
};

export default class InventoryManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stocks: [],
      dropdownOpen: false,
      selectedStore: null,
      stores: [],
      filterValue: "",
      filterData: [],
      spinnerLoading: false,
      priceModalVisible: false,
      selectedStock: null,
      storeInformation: null,
      categoryId:null,
      categoryName:null,
    };
  }
  
  componentDidMount() {
    this.setupInitialCondition();
    let category_id = this.props.match.params.id;
    let category_name = this.props.match.params.name;
    console.log('inventorymanagment category id',this.props.match.params.id );
    console.log('inventorymanagment category id',category_id );
    this.setState({ categoryId: category_id });
    this.setState({ categoryName: category_name });

    // if ("Notification" in window && Notification.permission !== "granted") {
    //   this.requestNotificationPermission();
    // }

    // try {
    //   player = document.getElementById("audio");
    // } catch (error) {
    //   console.log('Error on getElementById audio file', error);
    // }

    // this.fetchOrderInterval = setInterval(async () => {
    //   try {
    //     await this.get_order_count_for_notification();
    //   } catch (error) {
    //     console.error("Error fetching order count:", error);
    //   }
    // }, TIME_INTERVAL_ORDER);

  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.selectedStore !== null) {
      if (prevState.selectedStore === null) {
        this.getInventory();
        
      } else if (this.state.selectedStore.id !== prevState.selectedStore.id) {
        this.getInventory();
        
      }
    }
  }

  // componentWillUnmount() {
  //   clearInterval(this.fetchOrderInterval);
  // }


  togglePricetModal = () => {
    this.setState({
      priceModalVisible: !this.state.priceModalVisible,
    });
  };
  setupInitialCondition = async () => {
    let loginMode = localStorage.getItem("loginMode");
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    if (loginMode === "store") {
      console.log(storeInformation.store);
      this.setState({
        selectedStore: storeInformation.store,
        storeInformation: storeInformation,
      });
    } else {
      let stores = await this.getStores(storeInformation.merchant.id);
      if (stores) {
        this.setState({
          stores: stores,
          selectedStore: stores[0].node,
          storeInformation: storeInformation,
        });
      }
    }
    console.log(JSON.stringify(storeInformation));
  };

  getInventory = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getInventory",
      {
        storeId: this.state.selectedStore && this.state.selectedStore.id,
        referenceName_Icontains: "",
        //categoryID: "Q2F0ZWdvcnk6MDhlYmExZDktM2U3Zi00NGJiLThlMTctZTI2OGNkZjE1OTI4",
        categoryID: this.state.categoryId,
      }
    );
    console.log("getInventoryCategoryID",this.state.categoryId );
   // console.log("getInventory", JSON.stringify(response));
    if (response.error === null) {
      // this.setState({ stocks: response.data.stocks.edges });
      // let stocks = response.data.stocks.edges;
      // let ss = stocks.sort([]);
      this.setState((prevState) => ({
        stocks: response.data.stocks.edges,
        spinnerLoading: false,

        filterData: filterData(
          response.data.stocks.edges,
          prevState.filterValue
        ),
      }));
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "Unable to update inventory. Please check your internet connection."
      );
    }
  };
    // Peri Notification changes
    get_order_count_for_notification = async () =>{
      try {
        let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
        let authToken = storeInformation.token;
        var vtimestamp = generateEpochTimestamp();
        let response = await fetch(
            config.getHost() + "/order/getordercountfornotifications/",
            {
              method: "POST",
              headers: {
                Authorization: `Token ${authToken}`,
                "Content-Type": "application/json",
                Timestamp: vtimestamp,
                Signature: generateSignature(vtimestamp, authToken)                
              },
              body: JSON.stringify({
                store_id: storeInformation.store && storeInformation.store.id,
                graphql:true
              }),
            }
          );
    
        console.log("Response", response);
    
        if (response.status === 200) {
          let result = await response.json();
          if (result.SUCCESS) {
            let orderCount = result.ORDER_COUNT;
            console.log("Order Count:", orderCount);
    
            // Trigger a notification if there are new orders
            if (typeof orderCount === "number" && orderCount > 0)  {
              // showNotification("New Orders", `You have ${orderCount} new order(s)!, Please accept it`);
              this.showNotification("New Orders", `You have new order(s)! at your store, Please accept it`);
              this.playSound();
              // this.playSound();
            }
          }  
        } else {
          console.log("res", response.status);
        }
      } catch (error) {
        console.log("error", error);
    }
    };
    
    showNotification = (title, message) => {
      try{
      if (Notification.permission === "granted") {
        new Notification(title, { body: message, icon: noticationlogo });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            new Notification(title, { body: message, icon :noticationlogo, });
          }
        });
      }
    }
    catch(error){
      console.log('error in showNotification',error )
    }
    };
    
    playSound = () => {
      if (player) {
        if (player.paused) {
          let requestManager = new RequestManager();
          let sound = requestManager.getSoundFile();
          console.log("Playing sound: " + sound);
    
          try {
            player.src = require(`../../assets/sounds/${sound}.mp3`);
            player.load();
    
            // Set volume to full
            player.volume = 1;
    
            player.play().catch(error => console.error("Error playing sound:", error));
          } catch (error) {
            console.error("Error loading sound file:", error);
          }
        }
      } else {
        console.error("Player is null. Cannot play sound.");
      }
    };
  
    // Peri Notification changes
  
  
  toggleInStock = async (stock, inStock) => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let params = {
      input: {},
    };
    if (inStock === true) {
      params.input.inStockIds = [stock.node.id];
      params.input.outStockIds = [];
    } else if (inStock === false) {
      params.input.outStockIds = [stock.node.id];
      params.input.inStockIds = [];
    }

    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateStock",
      params
    );
    if (response.error === null) {
      let stocks = JSON.parse(JSON.stringify(this.state.stocks));
      let updatedStock = stocks.find((stateStock) => {
        return stateStock.node.id === stock.node.id;
      });

      // alert(JSON.stringify(updatedStock))
      updatedStock.node.inStock = inStock;
      this.setState({
        stocks: stocks,
        filterData: filterData(stocks),
        spinnerLoading: false,
      });
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "Unable to update inventory. Please check your internet connection."
      );
    }
  };

  getStores = async (merchantId) => {
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getStores",
      {
        merchantId: merchantId,
      }
    );

    if (response.error === null) {
      return response.data.merchant.stores.edges;
    }

    return null;
  };

  storeSelected = (store) => {
    if (this.state.selectedStore.id !== store.id) {
      this.setState({
        stocks: [],
        selectedStore: store,
        dropdownOpen: false,
      });
    }
  };
  hanldebackclick = () =>{
    this.props.history.goBack();
  }

  render() {
    const { filterData, spinnerLoading } = this.state;
    console.log(this.state.selectedStock,"selectedStock")
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Modal
            size="lg"
            isOpen={this.state.priceModalVisible}
            toggle={this.togglePricetModal}
          >
            <InventoryPrice
              goBack={this.togglePricetModal}
              refreshInventory={this.getInventory}
              stock={this.state.selectedStock}
            />
          </Modal>
          <Row noGutters>
            <Col xs="12">
              <Card>
                <CardHeader
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <button className="inventorybtn" onClick={this.hanldebackclick}>Back</button>
                <h5>Your inventory - {this.state.categoryName}</h5>
                  {this.renderStorePicker()}
                </CardHeader>

                <FormGroup style={{ margin: 15 }}>
                  <Label>Search</Label>
                  <Input
                    onChange={this.inputsearchChanged}
                    value={this.state.filterValue}
                    type="text"
                    name="search"
                    id="filter_body"
                    placeholder="Search item name,category."
                  />
                </FormGroup>
                {filterData &&
                  filterData.map((stock) => {
                    return (
                      <Card
                        style={{ padding: 10, marginRight: 10, marginLeft: 10 }}
                      >
                        <Row noGutters>
                          <div style={{ width: "70%" }}>
                            <p>
                              {stock.node.sku.quantity === null
                                ? stock.node.sku.product.category.name +
                                  " - " +
                                  stock.node.referenceName +
                                  " - " +
                                  stock.node.referenceId 
                                : stock.node.sku.product.category.name +
                                  " - " +
                                  stock.node.referenceName +
                                  " - " +
                                  stock.node.referenceId +
                                  " - " +
                                  stock.node.sku.quantity}
                            </p>
                            <p>{this.getLocalLangChina(stock)}</p>
                            <p style={{}}>
                              {"₹" + stock.node.sku.maximumRetailPrice}
                            </p>
                          </div>
                          <Switch
                            onChange={(checked, event, id) => {
                              this.toggleInStock(stock, checked);
                            }}
                            checked={stock.node.inStock}
                            id={stock.node.id}
                          />
                          
                        </Row>
                        {
                          //Price update for store owner
                          // (this.state.storeInformation.user &&
                          //   this.state.storeInformation.user.store_owner !==
                          //     true) ||
                          // (this.state.storeInformation.user &&
                          //   this.state.storeInformation.user.store_manager !==
                          //     true) ? (
                            (this.state.storeInformation.user &&
                            (this.state.storeInformation.user.store_owner === true ||
                              this.state.storeInformation.user.store_manager === true)
                              && stock.node.store.isPriceEdit === true)    ? (

                            <Row noGutters>
                              <p style={{ width: "70%" }}> </p>

                              <Button
                                color={"primary"}
                                style={{}}
                                onClick={() => {
                                  //alert(stock.node.sku.name);
                                  this.setState({
                                    priceModalVisible: true,
                                    selectedStock: stock,
                                  });
                                }}
                              >
                                {"Edit Price"}
                              </Button>
                            </Row>
                          ) : null
                        }
                      </Card>
                    );
                  })}
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }

  getLocalLangChina = (stock) => {
    let name = "";
    if (stock.node.locallngName !== null && stock.node.locallngName !== "") {
      if (stock.node.sku.quantity === null) {
        name =
          stock.node.sku.product.category.name +
          " - " +
          stock.node.locallngName;
      } else {
        name =
          stock.node.sku.product.category.name +
          " - " +
          stock.node.locallngName +
          " - " +
          stock.node.sku.quantity;
      }
    }

    return name;
  };
  inputsearchChanged = (e) => {
    this.setState({
      filterValue: e.target.value,
      filterData: filterData(this.state.stocks, e.target.value),
    });
  };
  renderStorePicker = () => {
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      return (
        <div>
          <ButtonDropdown
            isOpen={this.state.dropdownOpen}
            toggle={() => {
              this.setState({ dropdownOpen: !this.state.dropdownOpen });
            }}
          >
            <DropdownToggle caret>
              {this.state.selectedStore
                ? this.state.selectedStore.name
                : "Fetching stores.."}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem header>
                Choose a store to adjust inventory
              </DropdownItem>
              {this.state.stores.map((store) => (
                <DropdownItem
                  key={store.node.id}
                  onClick={() => {
                    this.storeSelected(store.node);
                  }}
                >
                  {store.node.name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </ButtonDropdown>
        </div>
      );
    }

    return <div />;
  };
}




// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/InventoryManagement.js